/* ============================================
   FCSportz Theme JavaScript
   Full Interactivity Module
   ============================================ */

(function () {
  'use strict';

  /* ============================================
     Sticky Header
     ============================================ */
  const header = document.querySelector('[data-header]');
  if (header && header.dataset.sticky === 'true') {
    const announcementBar = document.querySelector('.announcement-bar');
    let headerOffset = 0;
    let lastScroll = 0;

    function updateHeaderOffset() {
      headerOffset = announcementBar ? announcementBar.offsetHeight : 0;
    }

    function handleScroll() {
      const currentScroll = window.scrollY;

      if (currentScroll > headerOffset + 50) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }

      lastScroll = currentScroll;
    }

    updateHeaderOffset();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', updateHeaderOffset, { passive: true });
  }

  /* ============================================
     Mobile Menu
     ============================================ */
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
  const overlay = document.querySelector('[data-overlay]');

  function openMobileMenu() {
    if (mobileMenu) {
      mobileMenu.classList.add('is-active');
      if (overlay) overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileMenu() {
    if (mobileMenu) {
      mobileMenu.classList.remove('is-active');
      if (overlay) overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', openMobileMenu);
  }

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      closeMobileMenu();
      closeSearchOverlay();
      closeCartDrawer();
    });
  }

  /* Submenu Toggle */
  document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const sublist = this.nextElementSibling;
      if (sublist) {
        sublist.classList.toggle('is-open');
        this.classList.toggle('is-open');
      }
    });
  });

  /* ============================================
     Search Overlay
     ============================================ */
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('[data-search-input]');

  function openSearchOverlay() {
    if (searchOverlay) {
      searchOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      if (searchInput) {
        setTimeout(function () {
          searchInput.focus();
        }, 300);
      }
    }
  }

  function closeSearchOverlay() {
    if (searchOverlay) {
      searchOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', openSearchOverlay);
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearchOverlay);
  }

  /* Close search overlay when clicking outside form */
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) {
        closeSearchOverlay();
      }
    });
  }

  /* ============================================
     Cart Drawer
     ============================================ */
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerClose = document.querySelector('[data-cart-drawer-close]');

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-active');
      if (overlay) overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-active');
      if (overlay) overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', closeCartDrawer);
  }

  /* ============================================
     Announcement Bar Auto-Rotate
     ============================================ */
  const announcementBar = document.querySelector('[data-announcement-bar]');
  if (announcementBar) {
    const messages = announcementBar.querySelectorAll('.announcement-bar__message');
    if (messages.length > 1) {
      let currentIndex = 0;
      setInterval(function () {
        messages[currentIndex].classList.remove('is-active');
        currentIndex = (currentIndex + 1) % messages.length;
        messages[currentIndex].classList.add('is-active');
      }, 5000);
    }
  }

  /* ============================================
     Keyboard Accessibility (Escape key)
     ============================================ */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeSearchOverlay();
      closeCartDrawer();
    }
  });

  /* ============================================
     Product Variant Selection (Product Page)
     ============================================ */
  const variantRadios = document.querySelectorAll('[data-variant-option]');
  if (variantRadios.length > 0) {
    variantRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateProductForm();
      });
    });
  }

  function updateProductForm() {
    const productForm = document.querySelector('[data-product-form]');
    if (!productForm) return;

    const options = [];
    document.querySelectorAll('[data-variant-option]:checked').forEach(function (input) {
      options.push(input.value);
    });

    const variantId = findVariant(options);
    if (variantId) {
      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
      }

      updatePrice(variantId);
      updateUrl(variantId);
    }
  }

  function findVariant(selectedOptions) {
    if (!window.productVariants) return null;
    const match = window.productVariants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });
    return match ? match.id : null;
  }

  function updatePrice(variantId) {
    if (!window.productVariants) return;
    const variant = window.productVariants.find(function (v) {
      return v.id === variantId;
    });
    if (!variant) return;

    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare-price]');

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  function updateUrl(variantId) {
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-IN', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'INR'
    });
  }

  /* ============================================
     Quantity Selectors
     ============================================ */
  document.querySelectorAll('[data-quantity-selector]').forEach(function (selector) {
    const minus = selector.querySelector('[data-quantity-minus]');
    const plus = selector.querySelector('[data-quantity-plus]');
    const input = selector.querySelector('[data-quantity-input]');

    if (minus) {
      minus.addEventListener('click', function () {
        const val = parseInt(input.value);
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change'));
        }
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        const val = parseInt(input.value);
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });


  /* ============================================
     Product Gallery - Slide/Thumb Click
     ============================================ */
  document.querySelectorAll('[data-thumb-id]').forEach(function(thumb) {
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      var mediaId = this.dataset.thumbId;

      // Show the correct slide
      document.querySelectorAll('.product-gallery__slide').forEach(function(slide) {
        slide.classList.remove('is-active');
        if (slide.dataset.mediaId === mediaId) {
          slide.classList.add('is-active');
        }
      });

      // Highlight the correct thumb
      document.querySelectorAll('[data-thumb-id]').forEach(function(t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');
    });
  });

  /* ============================================
     Collection Sort Select
     ============================================ */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ============================================
     Option Input (toggle styling)
     ============================================ */
  document.querySelectorAll('[data-option-input]').forEach(function(input) {
    input.addEventListener('change', function() {
      // Remove is-selected from siblings
      var parent = this.closest('.product-option__values');
      if (parent) {
        parent.querySelectorAll('.product-option__value').forEach(function(label) {
          label.classList.remove('is-selected');
        });
      }
      // Add is-selected to current
      var label = this.closest('.product-option__value');
      if (label) label.classList.add('is-selected');

      // Update variant id
      updateVariantFromOptions();
    });
  });

  function updateVariantFromOptions() {
    var productDataEl = document.querySelector('[data-product-json]');
    if (!productDataEl) return;

    try {
      var productData = JSON.parse(productDataEl.textContent);
      var selectedOptions = [];
      document.querySelectorAll('[data-option-input]:checked').forEach(function(input) {
        selectedOptions.push(input.value);
      });

      var matchedVariant = productData.variants.find(function(variant) {
        return variant.options.every(function(opt, idx) {
          return opt === selectedOptions[idx];
        });
      });

      if (matchedVariant) {
        // Update hidden input
        var idInput = document.querySelector('[data-variant-id]');
        if (idInput) idInput.value = matchedVariant.id;

        // Update price display
        var priceContainer = document.querySelector('.product-page__price');
        if (priceContainer) {
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            priceContainer.innerHTML =
              '<span class="price price--sale">' + formatMoney(matchedVariant.price) + '</span>' +
              '<s class="price price--compare">' + formatMoney(matchedVariant.compare_at_price) + '</s>';
          } else {
            priceContainer.innerHTML =
              '<span class="price price--regular">' + formatMoney(matchedVariant.price) + '</span>';
          }
        }

        // Update add to cart button
        var submitBtn = document.querySelector('[data-add-to-cart-btn]');
        if (submitBtn) {
          if (matchedVariant.available) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Add to Cart';
          } else {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Sold Out';
          }
        }

        // Update URL
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', matchedVariant.id);
          window.history.replaceState({}, '', url);
        }
      }
    } catch(err) {
      console.error('Variant update error:', err);
    }
  }

  /* Window exposure for cart operations */
  window.FCSportz = {
    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,
    openMobileMenu: openMobileMenu,
    closeMobileMenu: closeMobileMenu
  };

})();

